import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import { Modal, ModalOverlay, ModalContent } from '@chakra-ui/react';

const CLASS_PREFIX = 'facebook-subscription-dialog';
const MODAL_Z_INDEX = 1000000000; // --scm-z_index-popup

const FacebookSubscriptionDialog = ({ isOpen = false, onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay zIndex={MODAL_Z_INDEX} />
      <ModalContent
        as="div"
        containerProps={{
          zIndex: MODAL_Z_INDEX,
        }}
        className={`${CLASS_PREFIX}-content`}
        data-e2e-id={CLASS_PREFIX}
      >
        <div className={`${CLASS_PREFIX}-body`}>
          <h3 className={`${CLASS_PREFIX}-title`}>
            {t('Subscription - Facebook - Dialog - title')}
          </h3>
          <p className={`${CLASS_PREFIX}-info`}>
            <Trans
              i18nKey="Subscription - Facebook - Dialog - info"
              components={{
                1: <br />,
                2: <span className={`${CLASS_PREFIX}-hint`} />,
              }}
            />
          </p>
        </div>
        <div className={`${CLASS_PREFIX}-footer`}>
          <button
            type="button"
            className={`${CLASS_PREFIX}-footer_cancel`}
            onClick={onClose}
          >
            {t('Subscription - Facebook - Dialog - cancel')}
          </button>
          <button
            type="button"
            className={`btn btn-color-primary ${CLASS_PREFIX}-footer_confirm`}
            onClick={onConfirm}
          >
            {t('Subscription - Facebook - Dialog - subscribe')}
          </button>
        </div>
      </ModalContent>
    </Modal>
  );
};

FacebookSubscriptionDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default FacebookSubscriptionDialog;
